import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import PublicHeader from "@/components/PublicHeader";
import { UserAvatar } from "@/components/UserAvatar";
import { api, errMsg, homeFor } from "@/lib/api";
import { getAttribution } from "@/lib/attribution";
import { useAuth } from "@/context/AuthContext";

const ImportedCard = ({ user, name, setName }) => (
  <div className="mb-10 flex items-center gap-4 rounded-2xl border bg-white p-5" data-testid="onboarding-linkedin-prefill">
    <UserAvatar user={user} className="h-14 w-14" testid="onboarding-avatar" />
    <div className="flex-1">
      <p className="text-xs font-semibold uppercase tracking-widest text-primary">Imported from LinkedIn</p>
      <Input className="mt-1.5" value={name} onChange={(e) => setName(e.target.value)} aria-label="Your name" data-testid="onboarding-name-input" />
    </div>
  </div>
);

export default function Onboarding() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [role, setRole] = useState("candidate");
  const [org, setOrg] = useState("");
  const [name, setName] = useState(user?.name || "");
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role_confirmed) return <Navigate to={homeFor(user)} replace />;
  const submit = async () => {
    try { await api.post("/auth/confirm-role", { role, org_name: org, name, attribution: getAttribution() }); const u = await refresh(); nav(homeFor(u)); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="min-h-screen"><PublicHeader />
      <main className="mx-auto max-w-lg px-4 py-16">
        {user.prefilled_from === "linkedin" && <ImportedCard user={user} name={name} setName={setName} />}
        <h1 className="text-3xl font-extrabold" data-testid="onboarding-title">How will you use JobPedestal?</h1>
        <div className="mt-8 grid gap-3">
          {[["candidate", "I'm exploring my next role"], ["recruiter", "I'm hiring or recruiting"]].map(([r, t]) => (
            <button key={r} data-testid={`onboarding-role-${r}`} onClick={() => setRole(r)} className={`rounded-xl border p-5 text-left font-medium transition-colors ${role === r ? "border-primary bg-blue-50" : "bg-white hover:border-slate-300"}`}>{t}</button>
          ))}
          {role === "recruiter" && <Input placeholder="Company / agency name" value={org} onChange={(e) => setOrg(e.target.value)} data-testid="onboarding-org-input" />}
          <Button onClick={submit} className="mt-3" data-testid="onboarding-continue-button">Continue</Button>
        </div>
      </main>
    </div>
  );
}
